module.exports = __webpack_public_path__ + "img/wallet-03.c31a57de.svg";